export function MembershipPurplePinkGradient() {
  return (
    <svg
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      className="invisible w-0 h-0"
    >
      <defs>
        <linearGradient
          id="member-purple-pink-gradient"
          x1="0"
          x2="1"
          y1="1"
          y2="1"
        >
          <stop
            offset="0%"
            className={`[stopColor:theme('colors.membership-gradient-stop.0')] dark:[stopColor:theme('colors.membership-gradient-stop-dark.0')]`}
          />
          <stop
            offset="50%"
            className={`[stopColor:theme('colors.membership-gradient-stop.0')] dark:[stopColor:theme('colors.membership-gradient-stop-dark.1')]`}
          />
          <stop
            offset="100%"
            className={`[stopColor:theme('colors.membership-gradient-stop.0')] dark:[stopColor:theme('colors.membership-gradient-stop-dark.2')]`}
          />
        </linearGradient>
      </defs>
    </svg>
  )
}
